import { render, staticRenderFns } from "./UserTypeSelect.vue?vue&type=template&id=284ec79e&scoped=true"
import script from "./UserTypeSelect.vue?vue&type=script&lang=js"
export * from "./UserTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./UserTypeSelect.vue?vue&type=style&index=0&id=284ec79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284ec79e",
  null
  
)

export default component.exports